import {GET_LATEST_UNEP_CERTIFICATE} from "../../../../enums/Profile/profile";

export const getLatesUnepCertificateAction = (data) => {
    return {
        type:GET_LATEST_UNEP_CERTIFICATE,
        payload:data,
    };
};
